import { formatCurrency } from '@cast/utils';

import { DateRangeUnsupportedBanner } from '../_components/DateRangeUnsupportedBanner';
import { WidgetLayout } from '../../../_components/ui/WidgetLayout';
import { useInventoryWorkloadsTimeRangeSelection } from '../../../_hooks/useInventoryWorkloadsTimeRangeSelection';

import { CrossAzCommunicationCard } from './_components/CrossAzCommunicationCard';
import { useCrossAzCommunicationCostsData } from './_hooks/useCrossAzCommunicationCostsData';
import { isCrossAzDateRangeSupported } from './_utils/isCrossAzDateRangeSupported';

const TITLE = 'Cross-AZ communication costs';
const TEST_ID = 'cross-az-communication-costs-card';

export const CrossAzCommunicationCostsCard = () => {
  const { timeZone, getRange } = useInventoryWorkloadsTimeRangeSelection();
  const { from, to } = getRange();
  const { topItems, datapoints, isLoading, isFetching, error, refetch } =
    useCrossAzCommunicationCostsData();

  const isCardLoading = isLoading || (!!error && isFetching);

  if (!isCrossAzDateRangeSupported(from, to)) {
    return (
      <WidgetLayout title={TITLE} testId={TEST_ID}>
        <DateRangeUnsupportedBanner testId={`${TEST_ID}-unsupported-range`} />
      </WidgetLayout>
    );
  }

  return (
    <CrossAzCommunicationCard
      title={TITLE}
      testId={TEST_ID}
      topItems={topItems.map((item) => ({
        id: item.id,
        name: item.name,
        color: item.color,
        value: item.cost,
      }))}
      datapoints={datapoints}
      timeZone={timeZone}
      unit=""
      formatValue={(value) =>
        formatCurrency(value, { maximumFractionDigits: 2 })
      }
      formatTick={(value) => `$${value}`}
      formatTooltipValue={(value) =>
        formatCurrency(Number(value), { maximumFractionDigits: 2 })
      }
      isLoading={isCardLoading}
      isFetching={isFetching}
      error={error}
      refetch={refetch}
    />
  );
};
